import { render, staticRenderFns } from "./PesquisaEducacaoNutricional.vue?vue&type=template&id=b777802e&scoped=true"
import script from "./PesquisaEducacaoNutricional.vue?vue&type=script&lang=js"
export * from "./PesquisaEducacaoNutricional.vue?vue&type=script&lang=js"
import style0 from "./PesquisaEducacaoNutricional.vue?vue&type=style&index=0&id=b777802e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b777802e",
  null
  
)

export default component.exports